'use client';

import clsx from 'clsx';
import { type FC, useState } from 'react';
import { useLeftRailContext } from '@/context/LeftRailContext';
import type { ContentGalleryComponent } from '@/types/content-gallery';
import { InlineGalleryOverlay } from '@/components/raven/Blocks/InlineGalleryBlock/Overlay';
import { ContentGallerySlide } from '@/components/raven/Blocks/ContentGalleryBlock/ContentGallerySlide';

import styles from '../styles.module.css';

const ContentGalleryOverlay = InlineGalleryOverlay;

export const ContentGallery: FC<ContentGalleryComponent> = ({
	galleryId,
	slides,
	variant,
}) => {
	const { isLeftRailVisible } = useLeftRailContext();
	const [slideIdx, setSlideIdx] = useState(0);
	const currentSlide = slides[slideIdx];

	if (!currentSlide) {
		return null;
	}

	return (
		<>
			<div
				className={clsx(styles.gallery, {
					[styles.fullWidth]: variant === 'full-width' && !isLeftRailVisible,
					[styles.inline]: variant === 'inline' || isLeftRailVisible,
				})}
			>
				<ContentGallerySlide
					galleryId={galleryId}
					setSlideIdx={setSlideIdx}
					slideIdx={slideIdx}
					slides={slides}
					{...currentSlide}
				/>
			</div>
			<ContentGalleryOverlay
				galleryId={galleryId}
				setSlideIdx={setSlideIdx}
				slideIdx={slideIdx}
				slides={slides}
			/>
		</>
	);
};
